export enum FrLoginInterface {
  NONE,
  UNKNOWN,
  USERNAME_PASSWORD,
  CHOICE,
  SUCCESS,
  FAILURE,
  SESSION_EXPIRED,
}
